import ClearIcon from "@mui/icons-material/Clear"
import { Button } from "@mui/material"
import { makeStyles } from "tss-react/mui-compat"
import React from "react"
import Modal from "react-modal"
import ReactPlayer from "react-player"

// This is a copy/paste from [video_id].ts page, to componitize video player
const useStyles = makeStyles()(
  (theme) => ({
    model: {
      inset: 0,
      background: "none",
    },
    warningText: {
      color: "white",
      textAlign: "center",
      width: "90%",
      margin: "2rem auto",
      ...theme.fonts.lato400,
      fontSize: "16px",
    },
  })
)

interface VideoPlayerProps {
  videoURL: string
  onClose: () => void
  isOpen: boolean
}

export const VideoPlayer = (props: VideoPlayerProps) => {
  const { videoURL, isOpen = true, onClose } = props
  const { classes } = useStyles()

  return (
    /*@ts-ignore children type error occurs because of upgrading to React 18*/
    <Modal
      preventScroll
      className={classes.model}
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Video Modal">
      <div className={classes.warningText}>
        <span tabIndex={0}>
          Videos are hosted by a third party, and may lack audio description, closed captions or
          transcripts.
        </span>
        <Button onClick={onClose} color="inherit" startIcon={<ClearIcon />}>
          Close
        </Button>
      </div>

      <ReactPlayer controls={true} url={videoURL} width="100%" height="100%" />
    </Modal>
  )
}
